"use client";

import React, { useMemo } from "react";
import { SessionProvider, useSession } from "next-auth/react";
import { useLocalStorage } from "utils";

export default function ViewModeSessionPatcher({ children }: { children: React.ReactNode }) {
  const { data: session } = useSession();
  const [viewAsClient] = useLocalStorage<boolean>("adminViewAsClient", false);

  const patchedSession = useMemo(() => {
    if (!session || !viewAsClient || !session.user?.isAdmin) return session;
    return {
      ...session,
      user: { ...session.user, isAdmin: false },
    };
  }, [session, viewAsClient]);

  return (
    <SessionProvider session={patchedSession}>
      {children}
    </SessionProvider>
  );
}